<template>
  <button
    :disabled="isDisabled"
    class="ais-Pagination-link custom-pagination-button"
    :class="{
      'ais-Pagination-item ais-Pagination-item--page': !isArrowButton,
      'ais-Pagination-item--disabled': isDisabled && !isSelected,
      'ais-Pagination-item--selected': isSelected,
      'custom-pagination-button__arrow-button': isArrowButton,
    }"
    @click="$emit('click')"
  >
    {{ label }}
  </button>
</template>

<script lang="ts">

export default defineComponent({
  name: 'PaginationReviews',
  props: {
    label: {
      type: [String, Number],
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isArrowButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
});

</script>

<style lang="scss" scoped>
$pagination-item-height: 36px;
$pagination-item-line-height: 30px;
$pagination-item-padding: 0.3rem 0.5rem;

.custom-pagination-button {
  &.ais-Pagination-link {
    @apply text-EXPONDO-primary-80;

    &.ais-Pagination-item {
      @apply text-EXPONDO-primary-80;

      border: none;
      height: $pagination-item-height;
      line-height: $pagination-item-line-height;
      padding: $pagination-item-padding;

      &--disabled {
        @apply text-EXPONDO-grey-60;
        @apply opacity-100;
        @apply cursor-not-allowed;
      }

      &--selected {
        background: none;
        font-weight: var(--font-weight--bold);
      }
    }
  }

  &__arrow-button {
    @apply box-content;

    &:hover,
    &:focus {
      @apply bg-EXPONDO-primary;
    }
  }
}
</style>
